<div class="daily-food-fact-container">
  <div class="daily-food-fact-nav-bar box">
    <div class="daily-food-fact-nav-bar-title">جدول ارزش غذایی</div>
    <div class="daily-food-fact-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div *ngIf="dataIsReady" class="daily-food-fact-holder box">
    <div
      *ngFor="let foodFact of foodFactsNames; let i = index; let first = first"
    >
      <div
        *ngIf="foodFactsAmount[i] !== -1"
        class="food-fact-cell box"
        [ngStyle]="{
          'border-top': first ? '1px solid #cccccc' : '',
          'margin-top': first ? '16px' : '0'
        }"
      >
        <div class="food-fact-cell-title">{{ foodFact }}</div>
        <div class="food-fact-cell-unit-holder">
          <div class="food-fact-cell-amount">
            {{ foodFactsAmount[i].toFixed(1) }}
          </div>
          <div class="food-fact-cell-unit">{{ foodFactsUnits[i] }}</div>
        </div>
      </div>
      <div
        *ngIf="foodFactsAmount[i] === -1"
        class="food-fact-cell box"
        [ngStyle]="{
          'border-top': first ? '1px solid #cccccc' : '',
          'margin-top': first ? '16px' : '0'
        }"
      >
        <div class="food-fact-cell-title">{{ foodFact }}</div>
        <div class="food-fact-cell-unit-holder">
          <div class="food-fact-cell-amount">0.0</div>
          <div class="food-fact-cell-unit">{{ foodFactsUnits[i] }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
